import type { ICustomQuestionTypeConfiguration } from 'survey-core';
import { northAmericanRegions } from '../constants/addressRegions.constants';

export const useClientFormQuestions = () => {
  // Client question types
  const clientQuestions: ICustomQuestionTypeConfiguration[] = [
    {
      name: 'client_first_name',
      title: 'Client First Name',
      defaultQuestionTitle: 'Client First Name',
      questionJSON: {
        type: 'text',
        placeholder: 'Enter first name...',
        isRequired: true,
        maxLength: 50,
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_last_name',
      title: 'Client Last Name',
      defaultQuestionTitle: 'Client Last Name',
      questionJSON: {
        type: 'text',
        placeholder: 'Enter last name...',
        isRequired: true,
        maxLength: 50,
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_address_1',
      title: 'Client Address 1',
      defaultQuestionTitle: 'Client Address 1',
      questionJSON: {
        type: 'text',
        placeholder: 'Enter street address...',
        isRequired: true,
        maxLength: 100,
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_address_2',
      title: 'Client Address 2',
      defaultQuestionTitle: 'Client Address 2',
      questionJSON: {
        type: 'text',
        placeholder: 'Enter apartment, suite, etc. (optional)...',
        maxLength: 100,
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_city',
      title: 'City',
      defaultQuestionTitle: 'City',
      questionJSON: {
        type: 'text',
        placeholder: 'Enter city...',
        isRequired: true,
        maxLength: 50,
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_state',
      title: 'State',
      defaultQuestionTitle: 'State',
      questionJSON: {
        type: 'dropdown',
        placeholder: 'Select state...',
        isRequired: true,
        choices: northAmericanRegions.flatMap((country) =>
          country.regions.map((region) => ({
            value: region.abbreviation,
            text: region.name,
          }))
        ),
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_postal_code',
      title: 'Postal Code',
      defaultQuestionTitle: 'Postal Code',
      questionJSON: {
        type: 'text',
        placeholder: 'Enter postal code...',
        isRequired: true,
        maxLength: 10,
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_phone',
      title: 'Client Phone',
      defaultQuestionTitle: 'Client Phone',
      questionJSON: {
        type: 'text',
        inputType: 'tel',
        placeholder: '(000) 000-0000',
        isRequired: true,
        maskType: 'pattern',
        maskSettings: {
          pattern: '(999) 999-9999',
        },
      },
      inheritBaseProps: true,
    },
    {
      name: 'client_email',
      title: 'Client Email',
      defaultQuestionTitle: 'Client Email',
      questionJSON: {
        type: 'text',
        inputType: 'email',
        placeholder: 'name@example.com',
        isRequired: true,
        maxLength: 100,
        validators: [{ type: 'email', text: 'Please enter a valid email address' }],
      },
      inheritBaseProps: true,
    },
  ];

  return { clientQuestions };
};
